import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { FaunaGoPreset } from '../theme/faunago'; // Adjust the import path as necessary
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { StoreRouterConnectingModule } from '@ngrx/router-store';

import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import { StoreModule } from '@ngrx/store';
import { appReducer } from './store/app.reducer';
import { AuthInterceptorService } from './auth/auth-interceptor.service';
import { ErrorInterceptor } from './error-interceptor.service';
import { LoadingInterceptor } from './services/loading.interceptor';
import { ConfirmationService, MessageService } from 'primeng/api';
import { EffectsModule } from '@ngrx/effects';
import { AuthEffects } from './auth/store/auth.effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { ObservationEffects } from './observations/store/observation.effects';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      StoreModule.forRoot(appReducer),
      EffectsModule.forRoot([AuthEffects, ObservationEffects]),
      StoreRouterConnectingModule.forRoot()
    ),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideAnimations(),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    MessageService,
    ConfirmationService,
    provideStoreDevtools({
      maxAge: 25, // Retains last 25 states
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
      trace: false, //  If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
      traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided as true)
      connectInZone: true, // If set to true, the connection is established within the Angular zone
    }),
    providePrimeNG({
      theme: {
        preset: FaunaGoPreset,
        options: {
          darkModeSelector: false || 'none',
        },
      },
    }),
  ],
};
